module.exports = __webpack_public_path__ + "static/img/A28.33ba1b54.jpg";